//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue' // 面包屑
import navigationComp from '~/components/help/navigation.vue' // 左侧导航
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'navigation-comp': navigationComp
  },
  asyncData ({ route }) {
    const arr = [
      'lang-help-instructions-for-using-vps.html',
      'lang-help-vps-product-classification.html',
      'lang-help-buy-vps-server-process.html',
      'lang-help-helpWin.html',
      'lang-help-helpMac.html',
      'lang-help-mt4-account-binding-process.html',
      'lang-help-mt5-account-binding-process.html',
      'lang-help-ctrader-account-binding-process.html'
    ]
    const activeIndex = arr.findIndex(item => item == route.name)
    return {
      activeIndex
    }
  },
  data () {
    return {
      content: {
        'zh-cn': `
        <div class="title-box">MT5账户绑定流程</div>
                  <p class="bold">
                      1、使用VPS内置MT5交易软件登录账户
                  </p>
                  <p>
                      1.1、打开VPS云主机，找到MetaTrader 5
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2、软件打开后，在左侧导航Expert Advisors - Advisors列表中，可以看到WikiFXDefense天眼盾脚本。如图所示：
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3、交易账号登录成功后，选择菜单 “Tools” – “Options”
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4、切换至 &nbsp;“Expert Advisors” ，勾选”Allow Dll …” ，如图所示：
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5、手动加载WikiFXDefense天眼盾脚本。(参考： <span>MT5手动加载WikiFXDefense天眼盾脚本方法</span>)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6、若Status状态显示为7个1，则表示账户绑定成功，(天眼盾脚本只做账户检测，不涉及任何交易，所以无需设置自动交易)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7、若Status状态未显示7个1，可参考<a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">常见问题处理</a>方式。
                  </p>
                  <p class="bold">
                      2、用户自己安装MT5进行登录操作
                  </p>
                  <p>
                      2.1、打开安装的MT5 软件：(此处省略安装步骤)。打开后，若左侧导航中未出现WikiFXDefense天眼盾脚本，如图所示：
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2、可选中 “Expert Advisors”，右键选择”Refresh”，通常情况WikiFXDefense天眼盾脚本会自动显示在列表中。(<span>若仍无显示，可再等待片刻重试，或者联系在线客服协助解决</span>)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3、账户登录成功后，手动加载WikiFXDefense天眼盾脚本。(参考： <span>MT5手动加载WikiFXDefense天眼盾脚本方法</span>)
                  </p>
                  <p>
                      <span class="bold">注：账户绑定成功后，天眼盾脚本需一直持续加载(只需要一个窗口加载即可。</span>若关闭该窗口或在该窗口加载其他EA，则会弹出禁止关闭的提示。
                  </p>
                  <p>
                      2.4、用户如需使用其他EA，可以在新窗口中加载(参考： <span>MT5打开品种窗口方式</span。
                  </p>
                  <p class="bold">
                      3、MT5手动加载WikiFXDefense天眼盾脚本方法(同正常加载其他EA方法)
                  </p>
                  <p>
                      方法1：点击需要加载WikiFXDefense脚本的品种窗口，使其处于激活状态。然后双击导航列表中的WikiFXDefense脚本，弹出加载提示窗口，点击OK按钮即可。如图所示：
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      若未出现OK按钮，则需勾选”Allow DLL…”
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      方法2：点击鼠标左键，将导航列表中的WikiFXDefense脚本拖入需要加载的品种窗口中，弹出加载提示窗口，点击OK按钮即可。
                  </p>
                  <p class="bold">
                      4、MT5打开品种窗口方式
                  </p>
                  <p>
                      方法1： 在左侧市场列表中，选中需要打开的品种，点击鼠标右键，选择： “Chart Window”。 如图所示
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      方法2： 选择菜单 “File”-“New Chart”，选中需要显示的品种。
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        zh: `
        <div class="title-box">MT5帳戶綁定流程</div>
                  <p class="bold">
                      1.使用VPS內建MT5交易軟體登入帳戶
                  </p>
                  <p>
                      1.1、開啟VPS雲端主機，找到MetaTrader 5
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2、軟體開啟後，在左側導覽Expert Advisors - Advisors清單中，可以看到WikiFXDefense天眼盾腳本。如圖所示：
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3、交易帳號登入成功後，選擇選單 “Tools” – “Options”
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4、切換至 “Expert Advisors” ，勾選”Allow Dll …” ，如圖所示：
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5、手動載入WikiFXDefense天眼盾腳本。(參考： <span>MT5手動載入WikiFXDefense天眼盾腳本方法</span>)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6、若Status狀態顯示為7個1，則表示帳戶綁定成功，(天眼盾腳本只做帳戶檢測，不涉及任何交易，所以無需設定自動交易)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7、若Status狀態未顯示7個1，可參考<a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">常見問題處理</a>方式。
                  </p>
                  <p class="bold">
                      2.用戶自行安裝MT5進行登入操作
                  </p>
                  <p>
                      2.1、開啟安裝的MT5 軟體：(此處省略安裝步驟)。 打開後，若左側導覽未出現WikiFXDefense天眼盾腳本，如圖所示：
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2、選用中 “Expert Advisors”，右鍵選擇”Refresh”，通常情況WikiFXDefense天眼盾腳本會自動顯示在列表中。(<span>若仍無顯示，可再等待片刻重試，或者聯繫在線客服協助解決</span>)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3、帳戶登入成功後，手動載入WikiFXDefense天眼盾腳本。(參考： <span>MT5手動載入WikiFXDefense天眼盾腳本方法</span>)
                  </p>
                  <p>
                      <span class="bold">註：帳戶綁定成功後，天眼盾腳本需一直持續載入(只需要一個視窗載入即可。</span>若關閉該視窗或在該視窗載入其他EA，則會彈出禁止關閉的提示。
                  </p>
                  <p>
                      2.4、使用者如需使用其他EA，可以在新視窗中載入(參考： <span>MT5開啟品種視窗方式</span>)。
                  </p>
                  <p class="bold">
                      3.MT5手動載入WikiFXDefense天眼盾腳本方法(同正常載入其他EA方法)
                  </p>
                  <p>
                      方法1：點選需要載入WikiFXDefense腳本的品種視窗，使其處於啟動狀態。然後雙擊導覽清單中的WikiFXDefense腳本，彈出載入提示視窗，點選OK按鈕即可。如圖所示：
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      若未出現OK按鈕，則需勾選”Allow DLL…”
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      方法2：點選滑鼠左鍵，將導覽清單中的WikiFXDefense腳本拖入需要載入的品種視窗中，彈出載入提示視窗，點擊OK按鈕即可。
                  </p>
                  <p class="bold">
                      4.MT5開啟品種窗口方式
                  </p>
                  <p>
                      方法1： 在左側市場清單中，選取需要開啟的品種，點選滑鼠右鍵，選擇： “Chart Window”。 如圖所示
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      方法2： 選擇選單 “File”-“New Chart”，選取需要顯示的品種。
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        en: `
        <div class="title-box">MT5 account binding process</div>
                          <p class="bold">
                              Log in to your account using the VPS built-in MT5 trading software
                          </p>
                  <p>
                      1.1. Open the VPS cloud host and find MetaTrader 5
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2. After the software is opened, in the Expert Advisors - Advisors list on the left navigation, you can see the WikiFXDefense Sky Eye Shield script. As shown in the figure:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3. After successfully logging in to the trading account, select the menu “Tools” – “Options”
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4. Switch to &quot;Expert Advisors&quot; and check &quot;Allow Dll...&quot;, as shown in the figure:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. Manually load the WikiFXDefense Sky Eye Shield script. (Reference: MT5 manual loading WikiFXDefense Sky Eye Shield script method)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6. If the Status shows 7 1s, it means the account is successfully bound. (The Sky Eye Shield script only does account detection and does not involve any transactions, so there is no need to set up automatic transactions)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7. If the Status does not display 7 1s, please refer to the <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQs</a>.
                  </p>
                          <p class="bold">
                              Users install MT5 themselves and log in.
                          </p>
                  <p>
                      2.1. Open the installed MT5 software: (the installation steps are omitted here). After opening, if the WikiFXDefense Sky Eye Shield script does not appear in the left navigation, as shown in the figure:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. You can select &quot;Expert Advisors&quot;, right-click and select &quot;Refresh&quot;. Normally, the WikiFXDefense Sky Eye Shield script will automatically be displayed in the list. (If it is still not displayed, you can wait a moment and try again, or contact online customer service for assistance)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. After the account login is successful, manually load the WikiFXDefense Sky Eye Shield script. (Reference: MT5 manual loading WikiFXDefense Sky Eye Shield script method)
                  </p>
                  <p>
                      Note: After the account is successfully bound, the Sky Eye Shield script needs to be loaded continuously (only one window is required to load). If you close this window or load other EAs in this window, a prompt prohibiting closing will pop up.
                  </p>
                  <p>
                      2.4. If users need to use other EAs, they can load them in a new window (reference: How to open the variety window in MT5).
                  </p>
                          <p class="bold">
                              MT5 manual loading method of WikiFXDefense Sky Eye Shield script (same as normal loading of other EA methods)
                          </p>
                  <p>
                      Method 1: Click on the product window that needs to load the WikiFXDefense script to make it active. Then double-click the WikiFXDefense script in the navigation list, a loading prompt window will pop up, and click the OK button. As shown in the figure:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      If the OK button does not appear, you need to check &quot;Allow DLL...&quot;
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      Method 2: Click the left mouse button, drag the WikiFXDefense script in the navigation list into the window of the product that needs to be loaded, a loading prompt window will pop up, and click the OK button.
                  </p>
                          <p class="bold">
                              How to open the variety window in MT5
                          </p>
                  <p>
                      Method 1: In the market list on the left, select the variety you want to open, right-click the mouse and select: “Chart Window”. As shown in the figure
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      Method 2: Select the menu &quot;File&quot;-&quot;New Chart&quot; and select the type to be displayed.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        ru: `
        <div class="title-box">Процесс привязки аккаунта МТ5</div>
                          <p class="bold">
                              Используйте встроенное торговое программное обеспечение MT5 VPS для входа в свою учетную запись.
                          </p>
                  <p>
                      1.1. Откройте облачный хост VPS и найдите MetaTrader 5.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2. После открытия программы в списке «Советники – Советники» на левой панели навигации вы увидите скрипт WikiFXDefense Sky Eye Shield, как показано на рисунке:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3. После успешного входа в торговый счет выберите меню «Инструменты» – «Параметры».
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4. Перейдите в «Советники» и установите флажок «Разрешить Dll...», как показано на рисунке:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. Вручную загрузите скрипт WikiFXDefense Sky Eye Shield (Ссылка: метод ручной загрузки скрипта WikiFXDefense Sky Eye Shield).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6. Если в Статусе отображается 7 единиц, это означает, что учетная запись успешно привязана (скрипт Sky Eye Shield только определяет учетную запись и не предполагает никаких транзакций, поэтому нет необходимости настраивать автоматические транзакции).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7. Если в статусе не отображается 7 1, обратитесь к часто <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">задаваемым вопросам</a>.
                  </p>
                          <p class="bold">
                              Пользователи сами устанавливают МТ5 и авторизуются.
                          </p>
                  <p>
                      2.1 Откройте установленное программное обеспечение MT5: (этапы установки здесь опущены). Если после открытия скрипт WikiFXDefense Sky Eye Shield не отображается в левой навигации, как показано на рисунке:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. Вы можете выбрать «Советники», щелкнуть правой кнопкой мыши и выбрать «Обновить». Обычно скрипт WikiFXDefense Sky Eye Shield автоматически отображается в списке (если он все еще не отображается, вы можете подождать немного и попробовать). еще раз или обратитесь за помощью в онлайн-службу поддержки клиентов)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. После успешного входа в учетную запись вручную загрузите сценарий WikiFXDefense Sky Eye Shield (Ссылка: метод сценария ручной загрузки WikiFXDefense Sky Eye Shield).
                  </p>
                  <p>
                      Примечание. После успешной привязки учетной записи скрипт Sky Eye Shield необходимо загружать постоянно (для загрузки требуется только одно окно). Если вы закроете это окно или загрузите в этом окне другие советники, появится сообщение, запрещающее закрытие.
                  </p>
                  <p>
                      2.4. Если пользователям необходимо использовать другие советники, они могут загрузить их в новом окне (ссылка: Как открыть окно разнообразия в MT5).
                  </p>
                          <p class="bold">
                              Метод ручной загрузки скрипта WikiFXDefense Sky Eye Shield в MT5 (так же, как и обычная загрузка других методов советника)
                          </p>
                  <p>
                      Способ 1. Щелкните окно продукта, в котором необходимо загрузить сценарий WikiFXDefense, чтобы сделать его активным. Затем дважды щелкните сценарий WikiFXDefense в списке навигации, появится всплывающее окно с подсказкой о загрузке, и нажмите кнопку «ОК», как показано на рисунке. фигура:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      Если кнопка ОК не появилась, нужно поставить галочку «Разрешить DLL...».
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      Способ 2: Нажмите левую кнопку мыши, перетащите скрипт WikiFXDefense в списке навигации в окно продукта, который необходимо загрузить, появится окно с подсказкой о загрузке, и нажмите кнопку ОК.
                  </p>
                          <p class="bold">
                              Как открыть окно разнообразия в МТ5
                          </p>
                  <p>
                      Способ 1: В списке рынков слева выберите продукт, который хотите открыть, щелкните правой кнопкой мыши и выберите: «Окно графика».
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      Способ 2: Выберите меню «Файл»-«Новая диаграмма» и выберите символ, который будет отображаться.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        ja: `
        <div class="title-box">MT5アカウントバインドプロセス</div>
                          <p class="bold">
                              VPS内蔵MT5取引ソフトウェアを使用してアカウントにログインします
                          </p>
                  <p>
                      1.1. VPS クラウド ホストを開き、MetaTrader 5 を見つけます。
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2. ソフトウェアを開いた後、左側のナビゲーションの Expert Advisors - Advisors リストに、図に示すように WikiFX Defense Sky Eye Shield スクリプトが表示されます。
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3. 取引口座に正常にログインしたら、メニュー「ツール」-「オプション」を選択します。
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4. 図に示すように、「Expert Advisors」に切り替えて、「Allow Dll...」にチェックを入れます。
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. WikiFX Defense Sky Eye Shield スクリプトを手動でロードします (参考: WikiFX Defense Sky Eye Shield スクリプトを手動でロードする方法)。
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6. ステータスに 7 つの 1 が表示されている場合は、アカウントが正常にバインドされていることを意味します (Sky Eye Shield スクリプトはアカウントの検出のみを行い、トランザクションは含まないため、自動トランザクションを設定する必要はありません)。
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7. ステータスに 7 つの 1 が表示されない場合は、<a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQ</a> を参照してください。
                  </p>
                          <p class="bold">
                              ユーザー自身がMT5をインストールし、ログインします。
                          </p>
                  <p>
                      2.1. インストールされた MT5 ソフトウェアを開きます (インストール手順はここでは省略します)。 開いた後、図に示すように、WikiFX Defense Sky Eye Shield スクリプトが左側のナビゲーションに表示されない場合:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. [エキスパート アドバイザー] を選択し、右クリックして [更新] を選択すると、通常、WikiFX Defense Sky Eye Shield スクリプトがリストに自動的に表示されます (それでも表示されない場合は、少し待ってから試してください)。もう一度お問い合わせいただくか、オンライン カスタマー サービスにお問い合わせください)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. アカウントのログインが成功したら、WikiFX Defense Sky Eye Shield スクリプトを手動でロードします (参考: MT5 の WikiFX Defense Sky Eye Shield スクリプトの手動ロード方法)。
                  </p>
                  <p>
                      注: アカウントが正常にバインドされた後、Sky Eye Shield スクリプトを継続的にロードする必要があります (ロードするのに必要なウィンドウは 1 つだけです)。このウィンドウを閉じるか、このウィンドウで他の EA をロードすると、閉じることを禁止するプロンプトが表示されます。
                  </p>
                  <p>
                      2.4. ユーザーが他の EA を使用する必要がある場合は、新しいウィンドウでロードできます (参考: MT5 でさまざまなウィンドウを開く方法)。
                  </p>
                          <p class="bold">
                              WikiFX Defense Sky Eye ShieldスクリプトのMT5手動ロード方法（他のEAメソッドの通常のロードと同じ）
                          </p>
                  <p>
                      方法 1: WikiFX Defense スクリプトをロードする必要がある製品ウィンドウをクリックしてアクティブにし、ナビゲーション リストで WikiFX Defense スクリプトをダブルクリックすると、ロード プロンプト ウィンドウが表示され、[OK] ボタンをクリックします。形：
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      [OK]ボタンが表示されない場合は、「DLLを許可する...」にチェックを入れる必要があります。
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      方法 2: マウスの左ボタンをクリックし、ナビゲーション リスト内の WikiFX Defense スクリプトをロードする必要がある製品のウィンドウにドラッグします。ロード プロンプト ウィンドウがポップアップ表示され、[OK] ボタンをクリックします。
                  </p>
                  <p>
                      4.MT5でバラエティウィンドウを開く方法
                  </p>
                  <p>
                      方法 1: 左側のマーケットリストで開きたい商品を選択し、マウスを右クリックして「チャートウィンドウ」を選択します。
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      方法２：メニュー「ファイル」－「新規チャート」を選択し、表示するシンボルを選択します。
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        th: `
        <div class="title-box">กระบวนการผูกบัญชี MT5</div>
                          <p class="bold">
                              ใช้ซอฟต์แวร์การซื้อขาย MT5 ในตัว VPS เพื่อเข้าสู่บัญชีของคุณ
                          </p>
                  <p>
                      1.1. เปิดโฮสต์คลาวด์ VPS และค้นหา MetaTrader 5
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2. หลังจากเปิดซอฟต์แวร์แล้ว ในรายการ Expert Advisors - Advisors ทางด้านซ้าย คุณจะเห็นสคริปต์ WikiFXDefense Sky Eye Shield ดังแสดงในรูป:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3. หลังจากเข้าสู่ระบบบัญชีซื้อขายสำเร็จแล้ว ให้เลือกเมนู “เครื่องมือ” – “ตัวเลือก”
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4. สลับไปที่ &quot;Expert Advisors&quot; และทำเครื่องหมายที่ &quot;Allow Dll...&quot; ดังแสดงในรูป:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. โหลดสคริปต์ WikiFXDefense Sky Eye Shield ด้วยตนเอง (อ้างอิง: MT5 การโหลดสคริปต์ WikiFXDefense Sky Eye Shield ด้วยตนเอง)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6. หากสถานะแสดง 7 1 แสดงว่าบัญชีถูกผูกไว้สำเร็จ (สคริปต์ Sky Eye Shield จะทำการตรวจสอบบัญชีเท่านั้นและไม่เกี่ยวข้องกับธุรกรรมใด ๆ ดังนั้นจึงไม่จำเป็นต้องตั้งค่าธุรกรรมอัตโนมัติ)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7. หากสถานะไม่แสดง 7 1 โปรด<a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">ดูที่คำถามที่พบบ่อย</a>
                  </p>
                          <p class="bold">
                              ผู้ใช้ติดตั้ง MT5 ด้วยตนเองและเข้าสู่ระบบ
                          </p>
                  <p>
                      2.1. เปิดซอฟต์แวร์ MT5 ที่ติดตั้ง: (ขั้นตอนการติดตั้งจะถูกละไว้ที่นี่) หลังจากเปิดขึ้น หากสคริปต์ WikiFXDefense Sky Eye Shield ไม่ปรากฏในการนำทางด้านซ้าย ดังแสดงในรูป:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. คุณสามารถเลือก &quot;Expert Advisors&quot; คลิกขวาและเลือก &quot;Refresh&quot; โดยปกติแล้วสคริปต์ WikiFXDefense Sky Eye Shield จะแสดงในรายการโดยอัตโนมัติ (หากยังไม่แสดง คุณสามารถรอสักครู่แล้วลอง) อีกครั้งหรือติดต่อฝ่ายบริการลูกค้าออนไลน์เพื่อขอความช่วยเหลือ)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. หลังจากเข้าสู่ระบบบัญชีสำเร็จแล้ว ให้โหลดสคริปต์ WikiFXDefense Sky Eye Shield ด้วยตนเอง (อ้างอิง: MT5 การโหลดสคริปต์ WikiFXDefense Sky Eye Shield ด้วยตนเอง)
                  </p>
                  <p>
                      หมายเหตุ: หลังจากที่ผูกบัญชีสำเร็จแล้ว จะต้องโหลดสคริปต์ Sky Eye Shield อย่างต่อเนื่อง (ต้องโหลดเพียงหน้าต่างเดียวเท่านั้น) หากคุณปิดหน้าต่างนี้หรือโหลด EA อื่น ๆ ในหน้าต่างนี้ ข้อความแจ้งห้ามปิดจะปรากฏขึ้น
                  </p>
                  <p>
                      2.4. หากผู้ใช้จำเป็นต้องใช้ EA อื่น พวกเขาสามารถโหลดได้ในหน้าต่างใหม่ (ข้อมูลอ้างอิง: วิธีเปิดหน้าต่างวาไรตี้ใน MT5)
                  </p>
                          <p class="bold">
                              วิธีการโหลด MT5 ด้วยตนเองของสคริปต์ WikiFXDefense Sky Eye Shield (เหมือนกับการโหลดวิธี EA อื่น ๆ ตามปกติ)
                          </p>
                  <p>
                      วิธีที่ 1: คลิกที่หน้าต่างผลิตภัณฑ์ที่ต้องการโหลดสคริปต์ WikiFXDefense เพื่อให้ใช้งานได้ จากนั้นดับเบิลคลิกที่สคริปต์ WikiFXDefense ในรายการนำทาง หน้าต่างพร้อมท์การโหลดจะปรากฏขึ้น และคลิกปุ่ม OK ดังที่แสดงใน รูป:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      หากปุ่ม OK ไม่ปรากฏขึ้น คุณจะต้องกาเครื่องหมายที่ &quot;Allow DLL...&quot;
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      วิธีที่ 2: คลิกปุ่มซ้ายของเมาส์ ลากสคริปต์ WikiFXDefense ในรายการการนำทางไปยังหน้าต่างของผลิตภัณฑ์ที่ต้องการโหลด หน้าต่างพร้อมท์การโหลดจะปรากฏขึ้น และคลิกปุ่มตกลง
                  </p>
                          <p class="bold">
                              วิธีเปิดหน้าต่างวาไรตี้ใน MT5
                          </p>
                  <p>
                      วิธีที่ 1: ในรายการตลาดทางด้านซ้าย ให้เลือกผลิตภัณฑ์ที่คุณต้องการเปิด คลิกขวาที่เมาส์แล้วเลือก: “หน้าต่างแผนภูมิ” ดังแสดงในรูป
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      วิธีที่ 2: เลือกเมนู &quot;ไฟล์&quot;-&quot;แผนภูมิใหม่&quot; และเลือกสัญลักษณ์ที่จะแสดง
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        vi: `
        <div class="title-box">Quy trình ràng buộc tài khoản MT5</div>
                          <p class="bold">
                              Sử dụng phần mềm giao dịch MT5 tích hợp VPS để đăng nhập vào tài khoản
                          </p>
                  <p>
                      1.1. Mở máy chủ đám mây VPS và tìm MetaTrader 5
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 Sau khi mở phần mềm, trong danh sách Expert Advisors - Advisors ở điều hướng bên trái, bạn có thể thấy tập lệnh WikiFXDefense Sky Eye Shield Như trong hình:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Sau khi đăng nhập thành công tài khoản giao dịch, chọn menu “Công cụ” – “Tùy chọn”
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 Chuyển sang &quot;Expert Advisors&quot; và chọn &quot;Cho phép Dll...&quot;, như trong hình:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. Tải tập lệnh WikiFXDefense Sky Eye Shield theo cách thủ công (Tham khảo: Phương pháp tải tập lệnh WikiFXDefense Sky Eye Shield theo cách thủ công.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6 Nếu Trạng thái hiển thị 7 1, nghĩa là tài khoản đã được liên kết thành công (Kịch bản Sky Eye Shield chỉ phát hiện tài khoản và không liên quan đến bất kỳ giao dịch nào nên không cần thiết lập giao dịch tự động).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7 Nếu Trạng thái không hiển thị 7 1, vui lòng tham <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">khảo Câu hỏi thường gặp</a>.
                  </p>
                          <p class="bold">
                              Người dùng tự cài đặt MT5 và đăng nhập.
                          </p>
                  <p>
                      2.1. Mở phần mềm MT5 đã cài đặt: (ở đây bỏ qua các bước cài đặt). Sau khi mở, nếu tập lệnh WikiFXDefense Sky Eye Shield không xuất hiện trong điều hướng bên trái, như trong hình:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2 Bạn có thể chọn &quot;Expert Advisors&quot;, nhấp chuột phải và chọn &quot;Refresh&quot;. Thông thường, tập lệnh WikiFXDefense Sky Eye Shield sẽ tự động hiển thị trong danh sách. một lần nữa, hoặc liên hệ với dịch vụ khách hàng trực tuyến để được hỗ trợ)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. Sau khi đăng nhập tài khoản thành công, hãy tải tập lệnh WikiFXDefense Sky Eye Shield theo cách thủ công (Tham khảo: Phương pháp tải tập lệnh WikiFXDefense Sky Eye Shield theo cách thủ công.
                  </p>
                  <p>
                      Lưu ý: Sau khi tài khoản được liên kết thành công, tập lệnh Sky Eye Shield cần được tải liên tục (chỉ cần tải một cửa sổ để tải). Nếu bạn đóng cửa sổ này hoặc tải các EA khác trong cửa sổ này, một lời nhắc cấm đóng sẽ bật lên.
                  </p>
                  <p>
                      2.4. Nếu người dùng cần sử dụng các EA khác, họ có thể tải chúng trong một cửa sổ mới (tham khảo: Cách mở cửa sổ đa dạng trong MT5).
                  </p>
                          <p class="bold">
                              Phương thức tải thủ công MT5 của tập lệnh WikiFXDefense Sky Eye Shield (giống như tải thông thường các phương pháp EA khác)
                          </p>
                  <p>
                      Phương pháp 1: Nhấp vào cửa sổ sản phẩm cần tải tập lệnh WikiFXDefense để kích hoạt. Sau đó nhấp đúp vào tập lệnh WikiFXDefense trong danh sách điều hướng, một cửa sổ nhắc tải sẽ bật lên và nhấp vào nút OK. nhân vật:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      Nếu nút OK không xuất hiện, bạn cần chọn &quot;Cho phép DLL...&quot;
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      Phương pháp 2: Nhấp chuột trái, kéo tập lệnh WikiFXDefense trong danh sách điều hướng vào cửa sổ của sản phẩm cần tải, cửa sổ nhắc tải sẽ bật lên và nhấp vào nút OK.
                  </p>
                          <p class="bold">
                              Cách mở cửa sổ đa dạng trong MT5
                          </p>
                  <p>
                      Cách 1: Trong danh sách thị trường bên trái, chọn sản phẩm bạn muốn mở, nhấp chuột phải và chọn: “Cửa sổ biểu đồ”.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      Cách 2: Chọn menu &quot;File&quot;-&quot;New Chart&quot; và chọn biểu tượng cần hiển thị.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        id: `
        <div class="title-box">Proses pengikatan akun MT5</div>
                          <p class="bold">
                              Gunakan perangkat lunak perdagangan MT5 bawaan VPS untuk masuk ke akun Anda
                          </p>
                  <p>
                      1.1. Buka host cloud VPS dan temukan MetaTrader 5
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2. Setelah perangkat lunak dibuka, pada daftar Expert Advisors - Advisors di navigasi kiri, Anda dapat melihat skrip WikiFXDefense Sky Eye Shield.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3. Setelah berhasil login ke akun trading, pilih menu “Tools” – “Options”
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4. Beralih ke &quot;Expert Advisors&quot; dan centang &quot;Allow Dll...&quot;, seperti yang ditunjukkan pada gambar:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. Memuat skrip WikiFXDefense Sky Eye Shield secara manual (Referensi: Manual MT5 memuat metode skrip WikiFXDefense Sky Eye Shield)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6. Jika Status menunjukkan 7 1, berarti akun berhasil diikat. (Script Sky Eye Shield hanya melakukan deteksi akun dan tidak melibatkan transaksi apa pun, jadi tidak perlu mengatur transaksi otomatis)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7. Jika Status tidak menampilkan 7 1, silakan merujuk ke <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQ</a>.
                  </p>
                          <p class="bold">
                              Pengguna menginstal MT5 sendiri dan login.
                          </p>
                  <p>
                      2.1. Buka perangkat lunak MT5 yang diinstal: (langkah-langkah instalasi dihilangkan di sini). Setelah dibuka, jika script WikiFXDefense Sky Eye Shield tidak muncul pada navigasi sebelah kiri, seperti terlihat pada gambar:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. Anda dapat memilih &quot;Expert Advisors&quot;, klik kanan dan pilih &quot;Refresh&quot;. Biasanya, skrip WikiFXDefense Sky Eye Shield akan otomatis ditampilkan dalam daftar (Jika masih belum ditampilkan, Anda dapat menunggu sebentar dan mencoba lagi, atau hubungi layanan pelanggan online untuk bantuan)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. Setelah login akun berhasil, muat skrip WikiFXDefense Sky Eye Shield secara manual (Referensi: Manual MT5 memuat metode skrip WikiFXDefense Sky Eye Shield)
                  </p>
                  <p>
                      Catatan: Setelah akun berhasil diikat, skrip Sky Eye Shield perlu dimuat secara terus-menerus (hanya diperlukan satu jendela untuk memuat). Jika Anda menutup jendela ini atau memuat EA lain di jendela ini, perintah yang melarang penutupan akan muncul.
                  </p>
                  <p>
                      2.4. Jika pengguna perlu menggunakan EA lain, mereka dapat memuatnya di jendela baru (referensi: Cara membuka jendela variasi di MT5).
                  </p>
                          <p class="bold">
                              Metode pemuatan manual MT5 dari skrip WikiFXDefense Sky Eye Shield (sama seperti pemuatan normal metode EA lainnya)
                          </p>
                  <p>
                      Metode 1: Klik pada jendela produk yang perlu memuat skrip WikiFXDefense untuk mengaktifkannya. Kemudian klik dua kali skrip WikiFXDefense di daftar navigasi, jendela prompt pemuatan akan muncul, dan klik tombol OK angka:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      Jika tombol OK tidak muncul, Anda perlu mencentang &quot;Izinkan DLL...&quot;
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      Metode 2: Klik tombol kiri mouse, seret skrip WikiFXDefense di daftar navigasi ke jendela produk yang perlu dimuat, jendela perintah pemuatan akan muncul, dan klik tombol OK.
                  </p>
                          <p class="bold">
                              Cara membuka jendela variasi di MT5
                          </p>
                  <p>
                      Metode 1: Pada daftar pasar di sebelah kiri, pilih produk yang ingin Anda buka, klik kanan mouse dan pilih: “Chart Window”.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      Metode 2: Pilih menu &quot;File&quot;-&quot;Bagan Baru&quot; dan pilih simbol yang akan ditampilkan.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        es: `
        <div class="title-box">Proceso de vinculación de cuenta MT5</div>
                          <p class="bold">
                              Utilice el software comercial MT5 integrado de VPS para iniciar sesión en su cuenta
                          </p>
                  <p>
                      1.1. Abra el host en la nube VPS y busque MetaTrader 5.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 Después de abrir el software, en la lista de Asesores Expertos - Asesores en la navegación izquierda, puede ver el script WikiFXDefense Sky Eye Shield como se muestra en la figura:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Después de iniciar sesión correctamente en la cuenta comercial, seleccione el menú &quot;Herramientas&quot; - &quot;Opciones&quot;.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 Cambie a &quot;Asesores expertos&quot; y marque &quot;Permitir Dll...&quot;, como se muestra en la figura:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. Cargue manualmente el script WikiFXDefense Sky Eye Shield (Referencia: método de script de carga manual MT5 de WikiFXDefense Sky Eye Shield).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6 Si el estado muestra 7 1, significa que la cuenta se vinculó correctamente (el script Sky Eye Shield solo detecta la cuenta y no implica ninguna transacción, por lo que no es necesario configurar transacciones automáticas).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7. Si el estado no muestra 7 1, consulte <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">las preguntas frecuentes</a>.
                  </p>
                          <p class="bold">
                              Los usuarios instalan MT5 ellos mismos e inician sesión.
                          </p>
                  <p>
                      2.1 Abra el software MT5 instalado: (aquí se omiten los pasos de instalación). Después de abrir, si el script WikiFXDefense Sky Eye Shield no aparece en la navegación izquierda, como se muestra en la figura:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. Puede seleccionar &quot;Asesores expertos&quot;, hacer clic derecho y seleccionar &quot;Actualizar&quot;. Normalmente, el script WikiFXDefense Sky Eye Shield se mostrará automáticamente en la lista (si aún no se muestra, puede esperar un momento e intentarlo). nuevamente o comuníquese con el servicio al cliente en línea para obtener ayuda)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3 Después de que el inicio de sesión de la cuenta sea exitoso, cargue manualmente el script WikiFXDefense Sky Eye Shield (Referencia: método de script de carga manual MT5 de WikiFXDefense Sky Eye Shield).
                  </p>
                  <p>
                      Nota: Una vez que la cuenta se haya vinculado correctamente, el script Sky Eye Shield debe cargarse continuamente (solo se requiere una ventana para cargar). Si cierra esta ventana o carga otros EA en esta ventana, aparecerá un mensaje que prohíbe el cierre.
                  </p>
                  <p>
                      2.4 Si los usuarios necesitan utilizar otros EA, pueden cargarlos en una nueva ventana (referencia: Cómo abrir la ventana de variedades en MT5).
                  </p>
                          <p class="bold">
                              Método de carga manual MT5 del script WikiFXDefense Sky Eye Shield (igual que la carga normal de otros métodos de EA)
                          </p>
                  <p>
                      Método 1: Haga clic en la ventana del producto que necesita cargar el script WikiFXDefense para activarlo. Luego haga doble clic en el script WikiFXDefense en la lista de navegación, aparecerá una ventana emergente y haga clic en el botón Aceptar. cifra:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      Si el botón Aceptar no aparece, debe marcar &quot;Permitir DLL...&quot;
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      Método 2: haga clic con el botón izquierdo del mouse, arrastre el script WikiFXDefense en la lista de navegación a la ventana del producto que debe cargarse, aparecerá una ventana emergente de carga y haga clic en el botón Aceptar.
                  </p>
                          <p class="bold">
                              Cómo abrir la ventana de variedades en MT5
                          </p>
                  <p>
                      Método 1: En la lista de mercados de la izquierda, seleccione el producto que desea abrir, haga clic con el botón derecho del mouse y seleccione: &quot;Ventana de gráfico como se muestra en la figura&quot;.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      Método 2: Seleccione el menú &quot;Archivo&quot; - &quot;Nuevo gráfico&quot; y seleccione el símbolo que se mostrará.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        hi: `
        <div class="title-box">MT5 खाता बाइंडिंग प्रक्रिया</div>
                          <p class="bold">
                              अपने खाते में लॉग इन करने के लिए VPS अंतर्निर्मित MT5 ट्रेडिंग सॉफ़्टवेयर का उपयोग करें
                          </p>
                  <p>
                      1.1. वीपीएस क्लाउड होस्ट खोलें और मेटाट्रेडर 5 खोजें
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2. सॉफ्टवेयर खुलने के बाद, बाएं नेविगेशन पर विशेषज्ञ सलाहकार - सलाहकार सूची में, आप विकीएफएक्सडिफेंस स्काई आई शील्ड स्क्रिप्ट देख सकते हैं जैसा कि चित्र में दिखाया गया है:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3. ट्रेडिंग खाते में सफलतापूर्वक लॉग इन करने के बाद, मेनू &quot;टूल्स&quot; - &quot;विकल्प&quot; चुनें।
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4. &quot;विशेषज्ञ सलाहकार&quot; पर स्विच करें और &quot;Dll की अनुमति दें...&quot; जांचें, जैसा कि चित्र में दिखाया गया है:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. WikiFXDefense स्काई आई शील्ड स्क्रिप्ट को मैन्युअल रूप से लोड करें (संदर्भ: MT5 मैन्युअल लोडिंग WikiFXDefense स्काई आई शील्ड स्क्रिप्ट विधि)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6. यदि स्थिति 7 1 दिखाती है, तो इसका मतलब है कि खाता सफलतापूर्वक बंध गया है (स्काई आई शील्ड स्क्रिप्ट केवल खाते का पता लगाती है और इसमें कोई लेनदेन शामिल नहीं है, इसलिए स्वचालित लेनदेन सेट करने की कोई आवश्यकता नहीं है)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7. यदि स्थिति 7 1 प्रदर्शित नहीं करती है, तो कृपया <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">अक्सर पूछे जाने वाले प्रश्न</a> देखें।
                  </p>
                          <p class="bold">
                              उपयोगकर्ता स्वयं MT5 इंस्टॉल करते हैं और लॉग इन करते हैं।
                          </p>
                  <p>
                      2.1. स्थापित MT5 सॉफ़्टवेयर खोलें: (स्थापना चरण यहां छोड़े गए हैं)। खोलने के बाद, यदि WikiFXDefense स्काई आई शील्ड स्क्रिप्ट बाएं नेविगेशन में दिखाई नहीं देती है, जैसा कि चित्र में दिखाया गया है:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. आप &quot;विशेषज्ञ सलाहकार&quot; का चयन कर सकते हैं, राइट-क्लिक करें और &quot;रीफ्रेश&quot; का चयन करें, आम तौर पर, विकीएफएक्सडिफेंस स्काई आई शील्ड स्क्रिप्ट स्वचालित रूप से सूची में प्रदर्शित होगी (यदि यह अभी भी प्रदर्शित नहीं हुई है, तो आप एक पल इंतजार कर सकते हैं और प्रयास कर सकते हैं)। पुनः, या सहायता के लिए ऑनलाइन ग्राहक सेवा से संपर्क करें)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. खाता लॉगिन सफल होने के बाद, विकीएफएक्सडिफेंस स्काई आई शील्ड स्क्रिप्ट को मैन्युअल रूप से लोड करें (संदर्भ: एमटी5 मैनुअल लोडिंग विकीएफएक्सडिफेंस स्काई आई शील्ड स्क्रिप्ट विधि)।
                  </p>
                  <p>
                      ध्यान दें: खाता सफलतापूर्वक बाउंड होने के बाद, स्काई आई शील्ड स्क्रिप्ट को लगातार लोड करने की आवश्यकता होती है (लोड करने के लिए केवल एक विंडो की आवश्यकता होती है)। यदि आप इस विंडो को बंद करते हैं या इस विंडो में अन्य ईएएस लोड करते हैं, तो बंद करने पर रोक लगाने वाला एक संकेत पॉप अप होगा।
                  </p>
                  <p>
                      2.4. यदि उपयोगकर्ताओं को अन्य ईए का उपयोग करने की आवश्यकता है, तो वे उन्हें एक नई विंडो में लोड कर सकते हैं (संदर्भ: एमटी5 में विविधता विंडो कैसे खोलें)।
                  </p>
                          <p class="bold">
                              WikiFXDefense स्काई आई शील्ड स्क्रिप्ट की MT5 मैन्युअल लोडिंग विधि (अन्य EA विधियों की सामान्य लोडिंग के समान)
                          </p>
                  <p>
                      विधि 1: उस उत्पाद विंडो पर क्लिक करें जिसे WikiFXDefense स्क्रिप्ट को सक्रिय करने के लिए लोड करने की आवश्यकता है। फिर नेविगेशन सूची में WikiFXDefense स्क्रिप्ट पर डबल-क्लिक करें, एक लोडिंग प्रॉम्प्ट विंडो पॉप अप होगी, और ओके बटन पर क्लिक करें आकृति:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      यदि ओके बटन दिखाई नहीं देता है, तो आपको &quot;डीएलएल की अनुमति दें...&quot; को जांचना होगा।
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      विधि 2: बाईं माउस बटन पर क्लिक करें, नेविगेशन सूची में WikiFXDefense स्क्रिप्ट को उस उत्पाद की विंडो में खींचें जिसे लोड करने की आवश्यकता है, एक लोडिंग प्रॉम्प्ट विंडो पॉप अप हो जाएगी, और ओके बटन पर क्लिक करें।
                  </p>
                          <p class="bold">
                              MT5 में वैरायटी विंडो कैसे खोलें
                          </p>
                  <p>
                      विधि 1: बाईं ओर बाज़ार सूची में, उस उत्पाद का चयन करें जिसे आप खोलना चाहते हैं, माउस पर राइट-क्लिक करें और चुनें: &quot;चार्ट विंडो&quot;।
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      विधि 2: मेनू &quot;फ़ाइल&quot; - &quot;नया चार्ट&quot; चुनें और प्रदर्शित होने वाले प्रतीक का चयन करें।
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        fil: `
        <div class="title-box">Proseso ng pagbubuklod ng MT5 account</div>
                          <p class="bold">
                              Gumamit ng VPS built-in MT5 trading software upang mag-log in sa iyong account
                          </p>
                  <p>
                      1.1. Buksan ang VPS cloud host at hanapin ang MetaTrader 5
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2. Pagkatapos mabuksan ang software, sa listahan ng Expert Advisors - Advisors sa kaliwang nabigasyon, makikita mo ang script ng WikiFXDefense Sky Eye Shield Gaya ng ipinapakita sa figure:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Pagkatapos ng matagumpay na pag-log in sa trading account, piliin ang menu na “Tools” – “Options”
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4. Lumipat sa &quot;Mga Expert Advisors&quot; at lagyan ng check ang &quot;Allow Dll...&quot;, tulad ng ipinapakita sa figure:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. Manu-manong i-load ang script ng WikiFXDefense Sky Eye Shield (Sanggunian: Manu-manong pagkarga ng paraan ng script ng WikiFXDefense Sky Eye Shield)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6. Kung ang Status ay nagpapakita ng 7 1s, ito ay nangangahulugan na ang account ay matagumpay na nakatali (Ang Sky Eye Shield ay gumagawa lamang ng pag-detect ng account at hindi nagsasangkot ng anumang mga transaksyon, kaya hindi na kailangang mag-set up ng mga awtomatikong transaksyon)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7 Kung ang Status ay hindi nagpapakita ng 7 1s, mangyaring sumangguni sa mga <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQ</a>.
                  </p>
                          <p class="bold">
                              Ang mga gumagamit ay nag-install ng MT5 sa kanilang sarili at nag-log in.
                          </p>
                  <p>
                      2.1. Buksan ang naka-install na MT5 software: (ang mga hakbang sa pag-install ay tinanggal dito). Pagkatapos buksan, kung ang script ng WikiFXDefense Sky Eye Shield ay hindi lilitaw sa kaliwang nabigasyon, tulad ng ipinapakita sa figure:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. Maaari mong piliin ang &quot;Mga Expert Advisors&quot;, i-right-click at piliin ang &quot;I-refresh&quot;. muli, o makipag-ugnayan sa online na customer service para sa tulong)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. Matapos matagumpay ang pag-log in sa account, manu-manong i-load ang script ng WikiFXDefense Sky Eye Shield (Sanggunian: Manu-manong pag-load ng MT5 na paraan ng script ng WikiFXDefense Sky Eye Shield)
                  </p>
                  <p>
                      Tandaan: Pagkatapos na matagumpay na ma-bound ang account, kailangang patuloy na i-load ang script ng Sky Eye Shield (isang window lang ang kailangan upang mai-load ang window na ito o mag-load ng iba pang EA sa window na ito, lalabas ang isang prompt na nagbabawal sa pagsasara).
                  </p>
                  <p>
                      2.4. Kung kailangan ng mga user na gumamit ng iba pang EA, maaari nilang i-load ang mga ito sa isang bagong window (reference: Paano buksan ang variety window sa MT5).
                  </p>
                          <p class="bold">
                              MT5 manual loading method ng WikiFXDefense Sky Eye Shield script (katulad ng normal na paglo-load ng iba pang paraan ng EA)
                          </p>
                  <p>
                      Paraan 1: Mag-click sa window ng produkto na kailangang i-load ang script ng WikiFXDefense upang gawin itong aktibo figure:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      Kung ang OK na pindutan ay hindi lilitaw, kailangan mong suriin ang &quot;Pahintulutan ang DLL...&quot;
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      Paraan 2: I-click ang kaliwang pindutan ng mouse, i-drag ang script ng WikiFXDefense sa listahan ng nabigasyon sa window ng produkto na kailangang i-load, lalabas ang isang window ng prompt sa paglo-load, at i-click ang OK na buton.
                  </p>
                          <p class="bold">
                              Paano buksan ang variety window sa MT5
                          </p>
                  <p>
                      Paraan 1: Sa listahan ng merkado sa kaliwa, piliin ang produkto na gusto mong buksan, i-right-click ang mouse at piliin ang: &quot;Chart Window&quot; Tulad ng ipinapakita sa figure
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      Paraan 2: Piliin ang menu na &quot;File&quot;-&quot;Bagong Chart&quot; at piliin ang simbolo na ipapakita.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        fr: `
        <div class="title-box">Processus de liaison de compte MT5</div>
                          <p class="bold">
                              Utilisez le logiciel de trading MT5 intégré à VPS pour vous connecter à votre compte
                          </p>
                  <p>
                      1.1. Ouvrez l&#39;hôte cloud VPS et recherchez MetaTrader 5.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2. Une fois le logiciel ouvert, dans la liste Expert Advisors - Advisors dans la navigation de gauche, vous pouvez voir le script WikiFXDefense Sky Eye Shield comme le montre la figure&nbsp;:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3. Après vous être connecté avec succès au compte de trading, sélectionnez le menu « Outils » – « Options »
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4. Basculez vers « Expert Advisors » et cochez « Autoriser Dll... », comme indiqué dans la figure&nbsp;:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. Chargez manuellement le script WikiFXDefense Sky Eye Shield (Référence&nbsp;: méthode de chargement manuel MT5 WikiFXDefense Sky Eye Shield).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6. Si le statut affiche 7 1, cela signifie que le compte est lié avec succès (le script Sky Eye Shield effectue uniquement la détection du compte et n&#39;implique aucune transaction, il n&#39;est donc pas nécessaire de configurer des transactions automatiques).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7. Si le statut n&#39;affiche pas 7 1, veuillez vous référer à la <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQ</a>.
                  </p>
                          <p class="bold">
                              Les utilisateurs installent eux-mêmes MT5 et se connectent.
                          </p>
                  <p>
                      2.1. Ouvrez le logiciel MT5 installé&nbsp;: (les étapes d&#39;installation sont omises ici). Après ouverture, si le script WikiFXDefense Sky Eye Shield n&#39;apparaît pas dans la navigation de gauche, comme le montre la figure&nbsp;:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. Vous pouvez sélectionner « Expert Advisors », faire un clic droit et sélectionner « Actualiser ». Normalement, le script WikiFXDefense Sky Eye Shield s&#39;affichera automatiquement dans la liste (s&#39;il n&#39;est toujours pas affiché, vous pouvez attendre un moment et essayer. à nouveau, ou contactez le service client en ligne pour obtenir de l&#39;aide)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. Une fois la connexion au compte réussie, chargez manuellement le script WikiFXDefense Sky Eye Shield (Référence&nbsp;: méthode de chargement manuel MT5 du script WikiFXDefense Sky Eye Shield).
                  </p>
                  <p>
                      Remarque&nbsp;: Une fois le compte lié avec succès, le script Sky Eye Shield doit être chargé en continu (une seule fenêtre est requise pour le chargement). Si vous fermez cette fenêtre ou chargez d&#39;autres EA dans cette fenêtre, une invite interdisant la fermeture apparaîtra.
                  </p>
                  <p>
                      2.4. Si les utilisateurs ont besoin d&#39;utiliser d&#39;autres EA, ils peuvent les charger dans une nouvelle fenêtre (référence : Comment ouvrir la fenêtre des variétés dans MT5).
                  </p>
                          <p class="bold">
                              Méthode de chargement manuel MT5 du script WikiFXDefense Sky Eye Shield (identique au chargement normal des autres méthodes EA)
                          </p>
                  <p>
                      Méthode 1&nbsp;: cliquez sur la fenêtre du produit qui doit charger le script WikiFXDefense pour le rendre actif. Ensuite, double-cliquez sur le script WikiFXDefense dans la liste de navigation, une fenêtre d&#39;invite de chargement apparaîtra et cliquez sur le bouton OK comme indiqué dans l&#39;image. chiffre:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      Si le bouton OK n&#39;apparaît pas, vous devez cocher &quot;Autoriser les DLL...&quot;
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      Méthode 2&nbsp;: cliquez sur le bouton gauche de la souris, faites glisser le script WikiFXDefense dans la liste de navigation vers la fenêtre du produit qui doit être chargé, une fenêtre d&#39;invite de chargement apparaîtra et cliquez sur le bouton OK.
                  </p>
                          <p class="bold">
                              Comment ouvrir la fenêtre des variétés dans MT5
                          </p>
                  <p>
                      Méthode 1 : Dans la liste des marchés à gauche, sélectionnez le produit que vous souhaitez ouvrir, cliquez avec le bouton droit de la souris et sélectionnez : «&nbsp;Fenêtre graphique&nbsp;».
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      Méthode 2 : Sélectionnez le menu &quot;Fichier&quot; - &quot;Nouveau graphique&quot; et sélectionnez le symbole à afficher.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        de: `
        <div class="title-box">MT5-Kontobindungsprozess</div>
                          <p class="bold">
                              Melden Sie sich mit der in VPS integrierten MT5-Handelssoftware bei Ihrem Konto an
                          </p>
                  <p>
                      1.1. Öffnen Sie den VPS-Cloud-Host und suchen Sie nach MetaTrader 5
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2. Nachdem die Software geöffnet wurde, können Sie in der Liste „Expert Advisors“ in der linken Navigation das WikiFXDefense Sky Eye Shield-Skript sehen, wie in der Abbildung gezeigt:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3. Nach erfolgreicher Anmeldung am Handelskonto wählen Sie das Menü „Extras“ – „Optionen“
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4. Wechseln Sie zu „Expert Advisors“ und aktivieren Sie „Dll zulassen ...“, wie in der Abbildung gezeigt:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. Laden Sie das WikiFXDefense Sky Eye Shield-Skript manuell (Referenz: MT5-Skriptmethode zum manuellen Laden von WikiFXDefense Sky Eye Shield).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6. Wenn der Status 7 Einsen anzeigt, bedeutet dies, dass das Konto erfolgreich gebunden ist (das Sky Eye Shield-Skript führt nur eine Kontoerkennung durch und beinhaltet keine Transaktionen, es besteht also keine Notwendigkeit, automatische Transaktionen einzurichten).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7. Wenn der Status nicht 7 1s anzeigt, lesen Sie bitte die <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQs</a>.
                  </p>
                          <p class="bold">
                              Benutzer installieren MT5 selbst und melden sich an.
                          </p>
                  <p>
                      2.1. Öffnen Sie die installierte MT5-Software: (die Installationsschritte entfallen hier). Wenn das WikiFXDefense Sky Eye Shield-Skript nach dem Öffnen nicht in der linken Navigation erscheint, wie in der Abbildung gezeigt:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. Sie können „Expert Advisors“ auswählen, mit der rechten Maustaste klicken und „Aktualisieren“ auswählen. Normalerweise wird das WikiFXDefense Sky Eye Shield-Skript automatisch in der Liste angezeigt erneut oder wenden Sie sich an den Online-Kundendienst, um Hilfe zu erhalten.)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. Nachdem die Kontoanmeldung erfolgreich war, laden Sie das WikiFXDefense Sky Eye Shield-Skript manuell (Referenz: MT5-Skriptmethode zum manuellen Laden von WikiFXDefense Sky Eye Shield).
                  </p>
                  <p>
                      Hinweis: Nachdem das Konto erfolgreich gebunden wurde, muss das Sky Eye Shield-Skript kontinuierlich geladen werden (zum Laden ist nur ein Fenster erforderlich. Wenn Sie dieses Fenster schließen oder andere EAs in diesem Fenster laden, wird eine Eingabeaufforderung angezeigt, die das Schließen verhindert).
                  </p>
                  <p>
                      2.4. Wenn Benutzer andere EAs verwenden müssen, können sie diese in einem neuen Fenster laden (Referenz: So öffnen Sie das Sortenfenster in MT5).
                  </p>
                          <p class="bold">
                              Manuelle MT5-Lademethode des WikiFXDefense Sky Eye Shield-Skripts (identisch mit dem normalen Laden anderer EA-Methoden)
                          </p>
                  <p>
                      Methode 1: Klicken Sie auf das Produktfenster, das das WikiFXDefense-Skript laden muss, um es zu aktivieren. Doppelklicken Sie dann auf das WikiFXDefense-Skript in der Navigationsliste. Ein Fenster mit der Ladeaufforderung wird angezeigt, und Sie klicken auf die Schaltfläche „OK“. Figur:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      Wenn die Schaltfläche „OK“ nicht angezeigt wird, müssen Sie „DLL zulassen…“ aktivieren.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      Methode 2: Klicken Sie mit der linken Maustaste, ziehen Sie das WikiFXDefense-Skript aus der Navigationsliste in das Fenster des Produkts, das geladen werden muss. Es erscheint ein Fenster mit einer Ladeaufforderung, und klicken Sie auf die Schaltfläche „OK“.
                  </p>
                          <p class="bold">
                              So öffnen Sie das Sortenfenster in MT5
                          </p>
                  <p>
                      Methode 1: Wählen Sie in der Marktliste links das Produkt aus, das Sie öffnen möchten, klicken Sie mit der rechten Maustaste und wählen Sie: „Chart-Fenster“.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      Methode 2: Wählen Sie das Menü „Datei“ – „Neues Diagramm“ und wählen Sie das anzuzeigende Symbol aus.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        pt: `
        <div class="title-box">Processo de vinculação de conta MT5</div>
                          <p class="bold">
                              Use o software de negociação MT5 integrado ao VPS para fazer login em sua conta
                          </p>
                  <p>
                      1.1. Abra o host da nuvem VPS e encontre o MetaTrader 5.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2. Após o software ser aberto, na lista Expert Advisors - Advisors na navegação esquerda, você pode ver o script WikiFXDefense Sky Eye Shield Conforme mostrado na figura:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3. Após fazer login com sucesso na conta de negociação, selecione o menu “Ferramentas” – “Opções”
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4. Mude para &quot;Expert Advisors&quot; e marque &quot;Permitir Dll...&quot;, conforme mostrado na figura:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 Carregar manualmente o script WikiFXDefense Sky Eye Shield (Referência: método de script de carregamento manual WikiFXDefense Sky Eye Shield do MT5).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6. Se o status mostrar 7 1s, significa que a conta foi vinculada com sucesso (o script Sky Eye Shield apenas detecta a conta e não envolve nenhuma transação, portanto não há necessidade de configurar transações automáticas).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7 Se o Status não exibir 7 1s, consulte as <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">Perguntas Frequentes</a>.
                  </p>
                          <p class="bold">
                              Os próprios usuários instalam o MT5 e fazem login.
                          </p>
                  <p>
                      2.1. Abra o software MT5 instalado: (as etapas de instalação são omitidas aqui). Após a abertura, se o script WikiFXDefense Sky Eye Shield não aparecer na navegação esquerda, conforme mostrado na figura:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. Você pode selecionar &quot;Expert Advisors&quot;, clicar com o botão direito e selecionar &quot;Atualizar&quot;. Normalmente, o script WikiFXDefense Sky Eye Shield será exibido automaticamente na lista (se ainda não for exibido, você pode esperar um momento e tentar. novamente ou entre em contato com o atendimento ao cliente on-line para obter assistência)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. Após o login da conta ser bem-sucedido, carregue manualmente o script WikiFXDefense Sky Eye Shield (Referência: carregamento manual do método de script WikiFXDefense Sky Eye Shield).
                  </p>
                  <p>
                      Nota: Depois que a conta for vinculada com sucesso, o script Sky Eye Shield precisa ser carregado continuamente (apenas uma janela é necessária para carregar). Se você fechar esta janela ou carregar outros EAs nesta janela, um prompt proibindo o fechamento aparecerá.
                  </p>
                  <p>
                      2.4. Caso os usuários precisem usar outros EAs, eles podem carregá-los em uma nova janela (referência: Como abrir a janela de variedades no MT5).
                  </p>
                          <p class="bold">
                              Método de carregamento manual MT5 do script WikiFXDefense Sky Eye Shield (igual ao carregamento normal de outros métodos EA)
                          </p>
                  <p>
                      Método 1: Clique na janela do produto que precisa carregar o script WikiFXDefense para torná-lo ativo. Em seguida, clique duas vezes no script WikiFXDefense na lista de navegação, uma janela de prompt de carregamento aparecerá e clique no botão OK conforme mostrado no. figura:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      Se o botão OK não aparecer, você precisa marcar &quot;Permitir DLL...&quot;
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      Método 2: Clique com o botão esquerdo do mouse, arraste o script WikiFXDefense da lista de navegação para a janela do produto que precisa ser carregado, uma janela de prompt de carregamento aparecerá e clique no botão OK.
                  </p>
                          <p class="bold">
                              Como abrir a janela de variedades no MT5
                          </p>
                  <p>
                      Método 1: Na lista de mercados à esquerda, selecione o produto que deseja abrir, clique com o botão direito do mouse e selecione: “Janela de gráfico conforme mostrado na figura”.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      Método 2: Selecione o menu “Arquivo”-“Novo Gráfico” e selecione o símbolo a ser exibido.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        tr: `
        <div class="title-box">MT5 hesap bağlama süreci</div>
                          <p class="bold">
                              Hesabınıza giriş yapmak için VPS&#39;nin yerleşik MT5 ticaret yazılımını kullanın
                          </p>
                  <p>
                      1.1 VPS bulut sunucusunu açın ve MetaTrader 5&#39;i bulun.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 Yazılım açıldıktan sonra sol taraftaki Uzman Danışmanlar - Danışmanlar listesinde, şekilde gösterildiği gibi WikiFXDefense Sky Eye Shield komut dosyasını görebilirsiniz:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 Yatırım hesabına başarılı bir şekilde giriş yaptıktan sonra “Araçlar” – “Seçenekler” menüsünü seçin.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 &quot;Uzman Danışmanlar&quot;a geçin ve şekilde gösterildiği gibi &quot;Dll&#39;ye İzin Ver...&quot; seçeneğini işaretleyin:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5 WikiFXDefense Sky Eye Shield komut dosyasını manuel olarak yükleyin (Referans: MT5 manuel yükleme WikiFXDefense Sky Eye Shield komut dosyası yöntemi)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6 Durum 7 1 gösteriyorsa bu, hesabın başarıyla bağlandığı anlamına gelir (Sky Eye Shield scripti yalnızca hesap tespiti yapar ve herhangi bir işlem içermez, dolayısıyla otomatik işlemler ayarlamanıza gerek yoktur).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7 Durumda 7 1 görüntülenmiyorsa lütfen <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">SSS&#39;ye bakın</a>.
                  </p>
                          <p class="bold">
                              Kullanıcılar MT5&#39;i kendileri kurup giriş yaparlar.
                          </p>
                  <p>
                      2.1 Kurulu MT5 yazılımını açın: (kurulum adımları burada atlanmıştır). Açıldıktan sonra, WikiFXDefense Sky Eye Shield betiği şekilde gösterildiği gibi sol gezinme bölmesinde görünmüyorsa:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2 &quot;Uzman Danışmanlar&quot;ı seçip sağ tıklayıp &quot;Yenile&quot;yi seçebilirsiniz. Normalde WikiFXDefense Sky Eye Shield betiği listede otomatik olarak görüntülenecektir (Eğer hala görüntülenmiyorsa, bir süre bekleyip deneyebilirsiniz. tekrar deneyin veya yardım için çevrimiçi müşteri hizmetlerine başvurun)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3 Hesap girişi başarılı olduktan sonra, WikiFXDefense Sky Eye Shield komut dosyasını manuel olarak yükleyin (Referans: MT5 manuel yükleme WikiFXDefense Sky Eye Shield komut dosyası yöntemi).
                  </p>
                  <p>
                      Not: Hesap başarıyla bağlandıktan sonra Sky Eye Shield komut dosyasının sürekli olarak yüklenmesi gerekir (yüklemek için yalnızca bir pencere gerekir). Bu pencereyi kapatırsanız veya bu pencereye başka EA&#39;lar yüklerseniz, kapatmayı yasaklayan bir istem açılacaktır.
                  </p>
                  <p>
                      2.4 Kullanıcıların başka EA&#39;ları kullanması gerekiyorsa, bunları yeni bir pencereye yükleyebilirler (referans: MT5&#39;te çeşitlilik penceresi nasıl açılır).
                  </p>
                          <p class="bold">
                              WikiFXDefense Sky Eye Shield komut dosyasının MT5 manuel yükleme yöntemi (diğer EA yöntemlerinin normal yüklenmesiyle aynı)
                          </p>
                  <p>
                      Yöntem 1: WikiFXDefense betiğini aktif hale getirmek için yüklemesi gereken ürün penceresine tıklayın. Ardından gezinme listesinde WikiFXDefense betiğine çift tıklayın, bir yükleme istemi penceresi açılacaktır ve Şekilde gösterildiği gibi Tamam düğmesine tıklayın. figür:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      Tamam düğmesi görünmüyorsa &quot;DLL&#39;ye İzin Ver...&quot; seçeneğini işaretlemeniz gerekir.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      Yöntem 2: Sol fare düğmesine tıklayın, gezinme listesindeki WikiFXDefense komut dosyasını yüklenmesi gereken ürünün penceresine sürükleyin, bir yükleme istemi penceresi açılacaktır ve Tamam düğmesine tıklayın.
                  </p>
                          <p class="bold">
                              MT5&#39;te çeşitlilik penceresi nasıl açılır?
                          </p>
                  <p>
                      Yöntem 1: Soldaki piyasa listesinden açmak istediğiniz ürünü seçin, fareye sağ tıklayın ve şekilde görüldüğü gibi “Grafik Penceresi” seçeneğini seçin.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      Yöntem 2: &quot;Dosya&quot;-&quot;Yeni Grafik&quot; menüsünü seçin ve görüntülenecek sembolü seçin.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        ko: `
        <div class="title-box">MT5 계정 바인딩 프로세스</div>
                          <p class="bold">
                              VPS에 내장된 MT5 거래 소프트웨어를 사용하여 계정에 로그인하세요.
                          </p>
                  <p>
                      1.1. VPS 클라우드 호스트를 열고 MetaTrader 5를 찾으세요.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2. 소프트웨어가 열리면 왼쪽 탐색 메뉴의 Expert Advisors - Advisors 목록에서 그림과 같이 WikiFXDefense Sky Eye Shield 스크립트를 볼 수 있습니다.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3. 거래 계좌에 성공적으로 로그인한 후 “도구” – “옵션” 메뉴를 선택하세요.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4. 그림과 같이 &quot;Expert Advisors&quot;로 전환하고 &quot;Dll 허용...&quot;을 선택합니다.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. WikiFXDefense Sky Eye Shield 스크립트를 수동으로 로드합니다(참조: MT5 수동 로딩 WikiFXDefense Sky Eye Shield 스크립트 방법).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6. 상태에 7 1이 표시되면 계정이 성공적으로 바인딩되었음을 의미합니다. (Sky Eye Shield 스크립트는 계정 감지만 수행하고 트랜잭션을 포함하지 않으므로 자동 트랜잭션을 설정할 필요가 없습니다.)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                      1.7. 상태가 7 1로 표시되지 않으면 <a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">FAQ</a>를 참조하세요.
                  </p>
                          <p class="bold">
                              사용자가 직접 MT5를 설치하고 로그인합니다.
                          </p>
                  <p>
                      2.1. 설치된 MT5 소프트웨어를 엽니다(여기에서는 설치 단계가 생략됨). 연 후 그림과 같이 WikiFXDefense Sky Eye Shield 스크립트가 왼쪽 탐색에 표시되지 않는 경우:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2. &quot;Expert Advisors&quot;를 선택하고 마우스 오른쪽 버튼을 클릭한 후 &quot;Refresh&quot;를 선택하면 됩니다. 일반적으로 WikiFXDefense Sky Eye Shield 스크립트가 자동으로 목록에 표시됩니다. (아직 표시되지 않으면 잠시 기다렸다가 시도해 보세요.) 다시 문의하거나 온라인 고객 서비스에 문의하여 도움을 받으세요.)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. 계정 로그인이 성공한 후 WikiFXDefense Sky Eye Shield 스크립트를 수동으로 로드합니다(참조: MT5 수동 로딩 WikiFXDefense Sky Eye Shield 스크립트 방법).
                  </p>
                  <p>
                      참고: 계정이 성공적으로 바인딩된 후에는 Sky Eye Shield 스크립트를 계속 로드해야 합니다(로드하려면 하나의 창만 필요함). 이 창을 닫거나 이 창에서 다른 EA를 로드하면 폐쇄를 금지하는 메시지가 나타납니다.
                  </p>
                  <p>
                      2.4.사용자가 다른 EA를 사용해야 하는 경우 새 창에서 로드할 수 있습니다(참조: MT5에서 다양한 창을 여는 방법).
                  </p>
                          <p class="bold">
                              WikiFXDefense Sky Eye Shield 스크립트의 MT5 수동 로딩 방법 (다른 EA 방법의 일반 로딩과 동일)
                          </p>
                  <p>
                      방법 1: WikiFXDefense 스크립트를 로드해야 하는 제품 창을 클릭하여 활성화합니다. 그런 다음 탐색 목록에서 WikiFXDefense 스크립트를 두 번 클릭하면 로딩 프롬프트 창이 팝업되고 확인 버튼을 클릭합니다. 수치:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      확인 버튼이 나타나지 않으면 &quot;DLL 허용...&quot;을 선택해야 합니다.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      방법 2: 마우스 왼쪽 버튼을 클릭하고 탐색 목록의 WikiFXDefense 스크립트를 로드해야 하는 제품 창으로 드래그하면 로딩 프롬프트 창이 팝업되고 확인 버튼을 클릭합니다.
                  </p>
                          <p class="bold">
                              MT5에서 버라이어티 창을 여는 방법
                          </p>
                  <p>
                      방법 1: 왼쪽 시장 목록에서 개설하려는 상품을 선택하고 마우스 오른쪽 버튼을 클릭한 후 그림과 같이 &quot;차트 창&quot;을 선택합니다.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      방법 2: 메뉴 &quot;파일&quot;-&quot;새 차트&quot;를 선택하고 표시할 기호를 선택합니다.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`,
        ar: `
        <div class="title-box">عملية ربط حساب MT5</div>
                          <p class="bold">
                              استخدم برنامج التداول MT5 المدمج في VPS لتسجيل الدخول إلى حسابك
                          </p>
                  <p>
                      1.1. افتح مضيف VPS السحابي وابحث عن MetaTrader 5
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon1.png')}"/>
                  </p>
                  <p>
                      1.2 بعد فتح البرنامج، في قائمة المستشارين الخبراء - المستشارين في شريط التنقل الأيسر، يمكنك رؤية البرنامج النصي WikiFXDefense Sky Eye Shield كما هو موضح في الشكل:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon2.png')}"/>
                  </p>
                  <p>
                      1.3 بعد تسجيل الدخول بنجاح إلى حساب التداول، حدد القائمة &quot;الأدوات&quot; - &quot;الخيارات&quot;.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon3.png')}"/>
                  </p>
                  <p>
                      1.4 قم بالتبديل إلى &quot;المستشارين الخبراء&quot; وحدد &quot;السماح بـ Dll...&quot;، كما هو موضح في الشكل:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon4.png')}"/>
                  </p>
                  <p>
                      1.5. قم بتحميل البرنامج النصي WikiFXDefense Sky Eye Shield يدويًا (المرجع: طريقة التحميل اليدوي لـ WikiFXDefense Sky Eye Shield).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon5.png')}"/>
                  </p>
                  <p>
                      1.6 إذا أظهرت الحالة 7 1، فهذا يعني أن الحساب قد تم ربطه بنجاح (يقوم البرنامج النصي Sky Eye Shield فقط بالكشف عن الحساب ولا يتضمن أي معاملات، لذلك ليست هناك حاجة لإعداد معاملات تلقائية).
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon6.png')}"/>
                  </p>
                  <p>
                    1.7 إذا لم تظهر الحالة 7 1،<a target="_blank" href="/${this.currLangCode()}/help/helpIssueVps.html" class="link">فيرجى الرجوع إلى الأسئلة الشائعة</a>
                  </p>
                          <p class="bold">
                              يقوم المستخدمون بتثبيت MT5 بأنفسهم وتسجيل الدخول.
                          </p>
                  <p>
                      2.1. افتح برنامج MT5 المثبت: (تم حذف خطوات التثبيت هنا). بعد الفتح، إذا لم يظهر البرنامج النصي WikiFXDefense Sky Eye Shield في شريط التنقل الأيسر، كما هو موضح في الشكل:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon7.png')}"/>
                  </p>
                  <p>
                      2.2 يمكنك تحديد &quot;المستشارون الخبراء&quot;، ثم النقر بزر الماوس الأيمن واختيار &quot;تحديث&quot;. في العادة، سيتم عرض البرنامج النصي WikiFXDefense Sky Eye Shield تلقائيًا في القائمة (إذا لم يتم عرضه بعد، يمكنك الانتظار لحظة والمحاولة مرة أخرى، أو اتصل بخدمة العملاء عبر الإنترنت للحصول على المساعدة)
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon8.png')}"/>
                  </p>
                  <p>
                      2.3. بعد نجاح تسجيل الدخول إلى الحساب، قم بتحميل البرنامج النصي WikiFXDefense Sky Eye Shield يدويًا (المرجع: التحميل اليدوي لطريقة البرنامج النصي WikiFXDefense Sky Eye Shield).
                  </p>
                  <p>
                      ملاحظة: بعد ربط الحساب بنجاح، يجب تحميل البرنامج النصي Sky Eye Shield بشكل مستمر (يلزم تحميل نافذة واحدة فقط إذا قمت بإغلاق هذه النافذة أو تحميل مناطق العد الأخرى في هذه النافذة، ستظهر رسالة تحظر الإغلاق).
                  </p>
                  <p>
                      2.4 إذا كان المستخدمون بحاجة إلى استخدام مناطق العد الأخرى، فيمكنهم تحميلها في نافذة جديدة (المرجع: كيفية فتح نافذة التنوع في MT5).
                  </p>
                          <p class="bold">
                              طريقة التحميل اليدوي MT5 لبرنامج WikiFXDefense Sky Eye Shield (مثل التحميل العادي لطرق EA الأخرى)
                          </p>
                  <p>
                      الطريقة الأولى: انقر فوق نافذة المنتج التي تحتاج إلى تحميل البرنامج النصي WikiFXDefense لتنشيطه، ثم انقر نقرًا مزدوجًا فوق البرنامج النصي WikiFXDefense في قائمة التنقل، ستظهر نافذة مطالبة بالتحميل، وانقر فوق الزر &quot;موافق&quot;. شكل:
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon9.png')}"/>
                  </p>
                  <p>
                      إذا لم يظهر الزر &quot;موافق&quot;، فأنت بحاجة إلى تحديد &quot;السماح بـ DLL...&quot;
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon10.png')}"/>
                  </p>
                  <p>
                      الطريقة الثانية: انقر فوق زر الماوس الأيسر، واسحب البرنامج النصي WikiFXDefense في قائمة التنقل إلى نافذة المنتج الذي يجب تحميله، وستنبثق نافذة مطالبة التحميل، وانقر فوق الزر &quot;موافق&quot;.
                  </p>
                          <p class="bold">
                              كيفية فتح نافذة التنوع في MT5
                          </p>
                  <p>
                      الطريقة الأولى: في قائمة السوق الموجودة على اليسار، حدد المنتج الذي تريد فتحه، ثم انقر بزر الماوس الأيمن وحدد: &quot;نافذة الرسم البياني&quot; كما هو موضح في الشكل
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon11.png')}"/>
                  </p>
                  <p>
                      الطريقة الثانية: حدد القائمة &quot;ملف&quot; - &quot;مخطط جديد&quot; وحدد الرمز الذي سيتم عرضه.
                  </p>
                  <p class="m24">
                      <img src="${require('~/assets/img/help/mt5-icon12.png')}"/>
                  </p>`
      }
    }
  },
  head () {
    return {
      title: this.$t('40591'),
      meta: [
        { name: 'Description', content: this.$t('40597') }
      ]
    }
  }
}
